<template>
  <div class="product-page">
    <!-- 整屏滚动模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <!-- 1920×1080 设计稿画布 -->
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <div class="section-inner">
          <!-- 模块一：产品首屏 -->
          <!-- 背景图（手机端用竖版） -->
          <img v-if="item.key === 'hero'" :src="isMobile ? ($i18n.locale === 'en' ? require('../assets/images/product/product-1-back-INTMOBILE.png') : require('../assets/images/product/product-1-back-MOBILE.png')) : item.bgImage" class="section-bg-hero" />
          <!-- wifi 图（仅桌面端） -->
          <img v-if="item.key === 'hero' && !isMobile" class="section-overlay-hero-wifi" src="../assets/images/product/product-1-wifi.png" alt="" />
          <!-- 手机图（仅桌面端，英文版单独切图） -->
          <img v-if="item.key === 'hero' && !isMobile" class="section-overlay-hero-phone" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-1-INTphone.png') : require('../assets/images/product/product-1-phone.png')" alt="" />
          <!-- 产品介绍 -->
          <div v-if="item.key === 'hero'" class="hero-desc">
            <div class="hero-title">{{ $t('product.heroTitle') }}</div>
            <div class="hero-subtitle">{{ $t('product.heroSubtitle') }}</div>
            <div class="hero-text">{{ mobileText($t('product.heroDesc')) }}</div>
          </div>
          <!-- 模块二：产品特点 -->
          <div v-if="item.key === 'bluetooth'" class="feature-grid">
            <!-- 手机端上部两列 -->
            <div class="feature-top">
            <!-- 左列 -->
            <div class="feature-col feature-col-left">
              <div class="painless-card">
                <div class="painless-title">{{ $t('product.painlessTitle') }}</div>
                <div class="painless-desc">{{ mobileText($t('product.painlessDesc')) }}</div>
                <img class="painless-img" src="../assets/images/product/product-2-girl.png" alt="无痛佩戴 更舒适" />
              </div>
              <div class="report-card">
                <div class="report-title">{{ $t('product.reportTitle') }}</div>
                <div class="report-desc">{{ mobileText($t('product.reportDesc')) }}</div>
                <img class="report-img" src="../assets/images/product/product-2-tu.png" alt="数据查看简单易懂" />
              </div>
            </div>
            <!-- 右列 -->
            <div class="feature-col feature-col-right">
              <div class="bluetooth-card">
                <div class="bluetooth-title">{{ $t('product.bluetoothTitle') }}</div>
                <div class="bluetooth-desc">{{ mobileText($t('product.bluetoothSubtitle')) }}</div>
                <img class="bluetooth-img" src="../assets/images/product/product-2-lanya.png" alt="蓝牙5.0传输" />
              </div>
              <div class="calib-card">
                <div class="calib-title">{{ $t('product.calibTitle') }}</div>
                <div class="calib-desc">{{ mobileText($t('product.calibDesc')) }}</div>
                <img class="calib-img" src="../assets/images/product/product-2-waike.png" alt="无需校准 更方便" />
              </div>
            </div>
            </div>
            <!-- 小巧便携（手机端通栏） -->
            <div class="compact-card">
              <div class="compact-title">{{ $t('product.compactTitle') }}</div>
              <div class="compact-desc">{{ mobileText($t('product.compactDesc')) }}</div>
              <img class="compact-img" src="../assets/images/product/product-2-xty.png" alt="小巧体积 佩戴便携" />
            </div>
          </div>
          <!-- 模块三：应用场景 -->
          <div v-if="item.key === 'compact'" class="block-content">
            <h2 class="section-title">{{ $t('product.sceneTitle') }}</h2>
            <div class="section-divider"></div>
            <p class="section-subtitle">{{ $t('product.sceneSubtitle') }}</p>
            <div class="scene-grid">
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneShower') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-shawwer.png" alt="居家" />
              </div>
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneWork') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-work.png" alt="工作" />
              </div>
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneSleep') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-sleep.png" alt="睡眠" />
              </div>
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneSport') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-swim.png" alt="运动" />
              </div>
            </div>
          </div>
          <!-- 模块四：控糖打卡 -->
          <div v-if="item.key === 'record'" class="block-content">
            <h2 class="section-title">{{ $t('product.recordTitle') }}</h2>
            <div class="section-divider"></div>
            <p class="section-subtitle">{{ $t('product.recordSubtitle') }}</p>
            <!-- 主图（英文版单独切图，手机端不加载） -->
            <img v-if="!isMobile" class="block-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/ctrl-gluINT.png') : require('../assets/images/product/ctrl-glu.png')" alt="控糖打卡" />
            <!-- 英文版运动打卡补充图（仅桌面端） -->
            <img v-if="!isMobile && $i18n.locale === 'en'" class="record-sport-img" src="../assets/images/product/product-2-4-INT.png" alt="运动打卡" />
            <!-- 手机端专用图（英文版单独切图） -->
            <img v-if="isMobile" class="record-mobile-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-4-INTmobile.png') : require('../assets/images/product/product-4-mobile.png')" alt="控糖打卡" />
          </div>
          <!-- 模块五：AGP 报告 -->
          <div v-if="item.key === 'scene'" class="agp-layout">
            <div class="agp-header">
              <h2 class="section-title">{{ $t('product.agpTitle') }}</h2>
              <div class="section-divider"></div>
              <p class="section-subtitle">{{ $t('product.agpSubtitle') }}</p>
            </div>
            <div class="agp-body">
              <div class="agp-text">
                <div class="agp-points">
                  <div class="agp-point">
                    <img class="agp-point-icon" src="../assets/images/product/product-5-dian.png" alt="" />
                    <p class="agp-point-text">{{ $t('product.agpPoint1') }}</p>
                  </div>
                  <div class="agp-point">
                    <img class="agp-point-icon" src="../assets/images/product/product-5-dian.png" alt="" />
                    <p class="agp-point-text">{{ $t('product.agpPoint2') }}</p>
                  </div>
                  <div class="agp-point">
                    <img class="agp-point-icon" src="../assets/images/product/product-5-dian.png" alt="" />
                    <p class="agp-point-text">{{ $t('product.agpPoint3') }}</p>
                  </div>
                </div>
              </div>
              <!-- AGP 图谱（英文版单独切图） -->
              <img class="agp-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-5-INTAGP.png') : require('../assets/images/product/product-5-AGP.png')" alt="AGP报告" />
            </div>
          </div>
          <!-- 模块六：血糖分析 -->
          <div v-if="item.key === 'analysis'" class="analysis-layout">
            <div class="analysis-header">
              <h2 class="section-title">{{ $t('product.analysisTitle') }}</h2>
              <div class="section-divider"></div>
              <p class="section-subtitle">{{ $t('product.analysisSubtitle') }}</p>
            </div>
            <!-- 手机端顺序：文字 → 血糖图 → 报告图 -->
            <div class="analysis-body">
              <!-- 报告截图（英文版单独切图） -->
              <img class="analysis-report-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-6-INTreport.png') : require('../assets/images/product/product-6-report.png')" alt="周期血糖报告" />
              <div class="analysis-text">
                <h3 class="analysis-expert-title">{{ $t('product.expertTitle') }}</h3>
                <ul class="analysis-points">
                  <li class="analysis-point">{{ $t('product.expertPoint1') }}</li>
                  <li class="analysis-point">{{ $t('product.expertPoint2') }}</li>
                </ul>
              </div>
              <!-- 血糖图（手机端排中间，英文版单独切图） -->
              <img class="analysis-glu-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-6-INTglu.png') : require('../assets/images/product/product-6-glu.png')" alt="血糖图表" />
            </div>
          </div>
          <!-- 模块七：三大模式 -->
          <div v-if="item.key === 'model'" class="model-layout">
            <div class="model-header">
              <h2 class="section-title">{{ $t('product.modelTitle') }}</h2>
              <div class="section-divider"></div>
              <p class="section-subtitle">{{ $t('product.modelSubtitle') }}</p>
            </div>
            <!-- 手机端横向轮播，桌面悬停遮罩 -->
            <div class="model-cards">
              <div class="model-card" :class="['role-' + ((0 - modelActive + 3) % 3), modelActive === 0 && modelInfoOpen ? 'show-info' : '', modelActive !== 0 && modelPrev !== 0 ? 'is-passing' : '']" @click="onModelTap(0)">
                <!-- 专业模式（手机端、英文版单独切图） -->
                <img class="model-card-img" :src="isMobile ? ($i18n.locale === 'en' ? require('../assets/images/product/product-7-mobileINTzhuanye.png') : require('../assets/images/product/product-7-mobilezhuanye.png')) : ($i18n.locale === 'en' ? require('../assets/images/product/product-7-INTzhuanye.png') : require('../assets/images/product/product-7-zhuanye.png'))" alt="专业模式" />
                <div class="model-card-overlay">
                  <h3 class="overlay-title">{{ $t('product.modePro') }}</h3>
                  <p class="overlay-desc">{{ $t('product.modeProDesc') }}</p>
                </div>
              </div>
              <div class="model-card" :class="['role-' + ((1 - modelActive + 3) % 3), modelActive === 1 && modelInfoOpen ? 'show-info' : '', modelActive !== 1 && modelPrev !== 1 ? 'is-passing' : '']" @click="onModelTap(1)">
                <!-- 亲友模式（手机端、英文版单独切图） -->
                <img class="model-card-img" :src="isMobile ? ($i18n.locale === 'en' ? require('../assets/images/product/product-7-mobileINTqinyou.png') : require('../assets/images/product/product-7-mobileqinyou.png')) : ($i18n.locale === 'en' ? require('../assets/images/product/product-7-INTqinyou.png') : require('../assets/images/product/product-7-qinyou.png'))" alt="亲友模式" />
                <div class="model-card-overlay">
                  <h3 class="overlay-title">{{ $t('product.modeFamily') }}</h3>
                  <p class="overlay-desc">{{ $t('product.modeFamilyDesc') }}</p>
                </div>
              </div>
              <div class="model-card" :class="['role-' + ((2 - modelActive + 3) % 3), modelActive === 2 && modelInfoOpen ? 'show-info' : '', modelActive !== 2 && modelPrev !== 2 ? 'is-passing' : '']" @click="onModelTap(2)">
                <!-- 关怀模式（手机端、英文版单独切图） -->
                <img class="model-card-img" :src="isMobile ? ($i18n.locale === 'en' ? require('../assets/images/product/product-7-mobileINTguanhuai.png') : require('../assets/images/product/product-7-mobileguanhuai.png')) : ($i18n.locale === 'en' ? require('../assets/images/product/product-7-INTguanhuai.png') : require('../assets/images/product/product-7-guanhuai.png'))" alt="关怀模式" />
                <div class="model-card-overlay">
                  <h3 class="overlay-title">{{ $t('product.modeCare') }}</h3>
                  <p class="overlay-desc">{{ $t('product.modeCareDesc') }}</p>
                </div>
              </div>
            </div>
            <!-- 手机端当前模式名 -->
            <p class="model-active-name">{{ modelActive === 0 ? $t('product.modePro') : modelActive === 1 ? $t('product.modeFamily') : $t('product.modeCare') }}</p>
          </div>
          <!-- 模块八：官方商城 -->
          <div v-if="item.key === 'shop'" class="block-content">
            <h2 class="section-title">{{ $t('product.officialShop') }}</h2>
            <div class="shop-links">
              <a href="https://cofoe.tmall.com/shop/view_shop.htm?ali_refid=a3_430582_1006:1124015931:H:bYEbOfJPdCHDafE2c8exZA%3D%3D:15fb641df49f28679c01fe1336358bdb&ali_trackid=282_15fb641df49f28679c01fe1336358bdb&spm=a21n57.1.1.1&pisk=gootLK1UmBAgjvxBwGYHnChSNDpHBeDwsfk5mSVGlXhKhWjDQlY4DjFKg54gf5jYDxhqijH2Q-NjGjFmSexoQAr4cQcvq3DZpTeAwfUffw9bERe6KP1tClW_cQAkDwXQ7CqjIgwrrW_QUWw1fPZXpyw4F1ZblRMBp-wc1ZssGv9LT8W1coajdwwzhoNjGo9KdWybcRGbcpHQT-G5hIFCCSjxJQunpQ7i9isjvRUB-ANCKonQBWN-CcIfctyTW7M_OCUp7C4I3rnV3iUxC4l4Ff16MSoKdcgSNBbg14exEqH6fMZibAg7l0OVlArg6kisytsjplFjZRzR6BFSbvizAyxWeviEsAoKnttbKbVIQcZvVLrTf5ZLLmAFfS3Ilc4a01OYgDHIfqIr20m8uE1uw-b6ppQVuPwUiS653tgHR7wLZdKAuZzeLJFkppQVuPwUp7v9HZ748p5..&mm_sceneid=1_0_112774535_0" target="_blank" rel="noopener" class="shop-link">
                <img src="../assets/images/product/tmall.png" alt="天猫" />
                <span>{{ $t('product.shopTmall') }}</span>
              </a>
              <a href="https://mall.jd.com/index-1000329903.html?from=pc" target="_blank" rel="noopener" class="shop-link">
                <img src="../assets/images/product/jd.png" alt="京东" />
                <span>{{ $t('product.shopJd') }}</span>
              </a>
              <a href="https://mobile.yangkeduo.com/goods.html?goods_id=683712113464&page_from=0&_oc_trace_mark=199&pxq_secret_key=SUJQPNW6SKWCMOWQ6KLCUWFZLOEPZ3WAEZJYKWGHNODBPVAHJIOQ&_oak_share_snapshot_num=14000&_oak_share_detail_id=30681184242&_oak_share_time=1793687778&share_oak_rcto=YWJCI8V6tsba74UO0yTY-wAbtxMqD8VaE8GYUDjBkmkvOEQRL4mOYGou&_oak_share_ticket=01-0000000029-16f9dfa14232f152ee8d1e851b272435235c15e39021db81c937e72b2e326402-1794983883&share_uin=PHGHTXYMRF3JCPZLNFN6AIMWAM_GEXDA&__wls_rt=1&__wls_lt=1&__wls_fm=n#pushState" target="_blank" rel="noopener" class="shop-link">
                <img src="../assets/images/product/pdd.png" alt="拼多多" />
                <span>{{ $t('product.shopPdd') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'ProductPage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero', bgImage: require('@/assets/images/product/product-1-back.png') }, // 首屏
        { key: 'bluetooth', className: 'module-bluetooth' }, // 产品特点
        { key: 'compact', className: 'module-compact' }, // 应用场景
        { key: 'record', className: 'module-record' }, // 控糖打卡
        { key: 'scene', className: 'module-scene' }, // AGP 报告
        { key: 'analysis', className: 'module-analysis' }, // 血糖分析
        { key: 'model', className: 'module-model' }, // 三大模式
        { key: 'shop', className: 'module-shop' } // 官方商城
      ],
      visibleMap: {},
      observer: null,
      isMobile: false,
      mobileQuery: null,
      // 轮播当前居中的卡片索引
      modelActive: 0,
      // 上一次居中的索引，用于定位横穿的第三张卡
      modelPrev: 0,
      // 中间卡是否展开介绍遮罩
      modelInfoOpen: false
    }
  },
  computed: {
    // 首屏是否可见（控制导航栏透明）
    heroVisible() {
      return !!this.visibleMap[0]
    }
  },
  watch: {
    // 首屏可见时导航栏透明
    heroVisible(val) {
      const header = document.querySelector('.header')
      if (header) {
        header.classList.toggle('header-transparent', val)
      }
    }
  },
  mounted() {
    // 记录初始 DPR，用于补偿浏览器缩放
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    // 手机端断点（与 CSS 一致）
    this.mobileQuery = window.matchMedia('(max-width: 1024px)')
    this.isMobile = this.mobileQuery.matches
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.onMobileChange)
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(this.onMobileChange)
    }
    this.initObserver()
    // 页脚 ?to= 参数定位模块
    this.scrollToQueryModule()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    // 离开产品页时清除导航栏透明态
    const header = document.querySelector('.header')
    if (header) {
      header.classList.remove('header-transparent')
    }
    if (this.mobileQuery) {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onMobileChange)
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onMobileChange)
      }
    }
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    onMobileChange(e) {
      this.isMobile = e.matches
    },
    // 点侧卡切到中间，点中间卡切换介绍
    onModelTap(i) {
      if (this.modelActive === i) {
        this.modelInfoOpen = !this.modelInfoOpen
      } else {
        this.modelPrev = this.modelActive
        this.modelActive = i
        this.modelInfoOpen = false
      }
    },
    mobileText(text) {
      // 手机端去掉 \n、把 | 转为换行；桌面去掉 |
      return this.isMobile
        ? String(text).replace(/\n/g, '').replace(/\|/g, '\n')
        : String(text).replace(/\|/g, '')
    },
    // 页脚锚点与模块选择器映射
    scrollToQueryModule() {
      const moduleMap = { shop: '.module-shop' }
      const selector = moduleMap[this.$route.query.to]
      if (!selector) {
        return
      }
      this.$nextTick(() => {
        const el = this.$el.querySelector(selector)
        if (el) {
          el.scrollIntoView()
        }
      })
    },
    updateScale() {
      // cover 模式：铺满窗口，非 16:9 时居中裁切
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      // 补偿浏览器缩放
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        // 不支持时直接全部显示
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    }
  }
}
</script>

<style scoped>

/* 整屏模块 */
.fullscreen-section {
  height: 100vh;
  /* 手机端可见高度 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
  background: #FFFFFF;
}

/* 设计稿画布 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入：仅透明度，隐藏态不设过渡以便重播 */
  opacity: 0;
  will-change: opacity;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transition: opacity 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 背景图 */
.section-bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

/* 通用内容块（模块三/五/六/七/八共用） */
.block-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
}

/* 分割线 */
.section-divider {
  width: 400px;
  height: 1px;
  background-color: #000000;
  margin: 0 auto 24px;
}

/* 副标题 */
.section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 30px;
  color: #000000;
  margin: 0 0 30px 0;
}

/* 主图 */
.block-img {
  max-width: 85%;
  max-height: 600px;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* 模块一：产品首屏 */

/* 首屏背景图，顶部对齐让图延伸到导航栏后 */
.section-bg-hero {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

/* wifi 图 */
.section-overlay-hero-wifi {
  position: absolute;
  top: 45.7%;
  left: 54%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: auto;
  object-fit: contain;
  z-index: 10;
}

/* 手机图 */
.section-overlay-hero-phone {
  position: absolute;
  top: 53%;
  left: 73%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: auto;
  object-fit: contain;
  z-index: 10;
}

/* 产品介绍 */
.hero-desc {
  position: absolute;
  top: 50%;
  left: 15%;
  width: 42%;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 28px;
  line-height: 1.9;
  color: #FFFFFF;
  text-align: left;
  z-index: 10;
}

/* 主标题 */
.hero-desc .hero-title {
  font-size: 40px;
  font-weight: 550;
  line-height: 1.6;
  margin-bottom: 8px;
}

/* 副标题 */
.hero-desc .hero-subtitle {
  font-size: 52px;
  font-weight: 550;
  line-height: 1.2;
  margin-bottom: 28px;
}

/* 正文（pre-line 保留 \n 换行） */
.hero-desc .hero-text {
  font-size: 24px;
  font-weight: 200;
  line-height: 1.5;
  white-space: pre-line;
  opacity: 0.6;
}

/* 英文版字号 */
:lang(en) .hero-desc .hero-title {
  font-size: 40px;
}

:lang(en) .hero-desc .hero-subtitle {
  font-size: 40px;
}

:lang(en) .hero-desc .hero-text {
  font-size: 24px;
  text-transform: capitalize;
  text-align: justify;
}

/* 首屏文字入场动效 */

/* 标题组 */
.reveal-section .hero-desc .hero-title,
.reveal-section .hero-desc .hero-subtitle {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .hero-desc .hero-title,
.reveal-section.is-visible .hero-desc .hero-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.1s,
    transform 1.1s ease 0s;
}

/* 正文 */
.reveal-section .hero-desc .hero-text {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .hero-desc .hero-text {
  opacity: 0.6;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.3s,
    transform 1.1s ease 0.2s;
}

/* 手机图入场：从小到大淡入（保留 -50% 居中位移） */
.reveal-section .section-overlay-hero-phone {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
}

.reveal-section.is-visible .section-overlay-hero-phone {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
  transition: opacity 1.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s,
    transform 1.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
}

/* 模块二：产品特点 */

/* 五个灰块的居中容器 */
.feature-grid {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1530px;
  height: 100%;
  z-index: 10;
}

/* 桌面端容器透明化，卡片由 .feature-grid 定位约束 */
.feature-top,
.feature-col {
  display: contents;
}

/* 无痛佩戴灰块 */
.painless-card {
  position: absolute;
  top: 24%;
  left: 0;
  width: 450px;
  height: 650px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  overflow: hidden;
  z-index: 10;
}

/* 标题（pre-line 保留 \n 换行） */
.painless-card .painless-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

.painless-card .painless-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 人物图，压在文字下层 */
.painless-card .painless-img {
  position: absolute;
  left: 70%;
  bottom: 0;
  transform: translateX(-50%);
  width: 60%;
  height: auto;
  object-fit: contain;
  z-index: -1;
}

/* 蓝牙传输灰块 */
.bluetooth-card {
  position: absolute;
  top: 24%;
  left: 480px;
  width: 330px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

.bluetooth-card .bluetooth-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

.bluetooth-card .bluetooth-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 蓝牙图标，压在文字下层 */
.bluetooth-card .bluetooth-img {
  position: absolute;
  top: 38%;
  left: 73%;
  transform: translateX(-50%);
  width: 42%;
  height: auto;
  object-fit: contain;
  z-index: -1;
}

/* 无需校准灰块 */
.calib-card {
  position: absolute;
  top: 24%;
  left: 840px;
  width: 690px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

.calib-card .calib-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

.calib-card .calib-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 产品图，压在文字下层 */
.calib-card .calib-img {
  position: absolute;
  top: 65%;
  right: 20%;
  transform: translateY(-50%);
  height: 110%;
  width: auto;
  object-fit: contain;
  z-index: -1;
}

/* 小巧便携灰块（第二行） */
.compact-card {
  position: absolute;
  top: 55.5%;
  left: 480px;
  width: 690px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

.compact-card .compact-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

.compact-card .compact-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 产品图，压在文字下层 */
.compact-card .compact-img {
  position: absolute;
  top: 55%;
  right: 7%;
  transform: translateY(-50%);
  height: 80%;
  width: auto;
  object-fit: contain;
  z-index: -1;
}

/* 数据报告灰块（第二行） */
.report-card {
  position: absolute;
  top: 55.5%;
  left: 1200px;
  width: 330px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

/* 标题（块较窄，字号单独控制） */
.report-card .report-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.0;
  margin-bottom: 10px;
  white-space: pre-line;
}

.report-card .report-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 图谱，压在文字下层 */
.report-card .report-img {
  position: absolute;
  top: 38%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: auto;
  object-fit: contain;
  z-index: -1;
}

/* 英文版字号 */

:lang(en) .painless-card .painless-title {
  font-size: 24px;
}

:lang(en) .painless-card .painless-desc {
  font-size: 18px;
}

:lang(en) .bluetooth-card .bluetooth-title {
  font-size: 24px;
}

:lang(en) .bluetooth-card .bluetooth-desc {
  font-size: 18px;
}

:lang(en) .calib-card .calib-title {
  font-size: 24px;
}

:lang(en) .calib-card .calib-desc {
  font-size: 18px;
}

:lang(en) .compact-card .compact-title {
  font-size: 24px;
}

:lang(en) .compact-card .compact-desc {
  font-size: 18px;
}

:lang(en) .report-card .report-title {
  font-size: 24px;
}

:lang(en) .report-card .report-desc {
  font-size: 18px;
}

/* 灰块入场动效 */

/* 无痛佩戴 */
.reveal-section .painless-card {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .painless-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.1s,
    transform 1.1s ease 0.1s;
}

/* 蓝牙传输 */
.reveal-section .bluetooth-card {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .bluetooth-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 无需校准 */
.reveal-section .calib-card {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .calib-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 小巧便携 */
.reveal-section .compact-card {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .compact-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.6s,
    transform 1.1s ease 0.6s;
}

/* 数据报告 */
.reveal-section .report-card {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .report-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.8s,
    transform 1.1s ease 0.8s;
}

/* 模块三：应用场景 */

/* 浅灰背景 */
.module-compact {
  background: #F5F5F5;
}

/* 大标题 */
.module-compact .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.6;
  margin: 20px 0 10px 0;
}

/* 小标题 */
.module-compact .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #868686;
  margin: 0 0 30px 0;
}

/* 四个白块容器 */
.scene-grid {
  display: flex;
  gap: 60px;
  margin-top: 20px;
}

/* 单个白块 */
.scene-grid .scene-block {
  display: flex;
  flex-direction: column;
  width: 330px;
  height: 498px;
  background: #FFFFFF;
  border-radius: 24px;
  box-sizing: border-box;
  padding: 16px 16px 0 0;
}

/* 场景图 */
.scene-grid .scene-block-img {
  width: 90%;
  height: auto;
  object-fit: contain;
  margin: 30px auto 0;
  transform: translateX(8px);
}

.scene-grid .scene-block-title {
  font-size: 26px;
  font-weight: 400;
  margin-top: 10px;
  padding-left: 26px;
  text-align: left;
  color: #000000;
  line-height: 1.2;
}

/* 白块入场动效 */

/* 标题/下划线/小标题入场 */
.module-compact .section-title,
.module-compact .section-divider,
.module-compact .section-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-compact.is-visible .section-title,
.module-compact.is-visible .section-divider,
.module-compact.is-visible .section-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

.reveal-section .scene-grid .scene-block {
  opacity: 0;
  transform: translateY(60px);
}

.reveal-section.is-visible .scene-grid .scene-block {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.1s,
    transform 1.1s ease 0.1s;
}

/* 依次错开 0.2s */
.reveal-section.is-visible .scene-grid .scene-block:nth-child(2) {
  transition-delay: 0.2s;
}

.reveal-section.is-visible .scene-grid .scene-block:nth-child(3) {
  transition-delay: 0.3s;
}

.reveal-section.is-visible .scene-grid .scene-block:nth-child(4) {
  transition-delay: 0.4s;
}

/* 模块四：控糖打卡 */

/* 白色背景 */
.module-record {
  background: #FFFFFF;
}

/* 大标题 */
.module-record .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 70px 0 20px 0;
}

/* 小标题 */
.module-record .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #868686;
  margin: 0 0 10px 0;
}

/* 主图 */
.module-record .block-img {
  height: 620px;
  width: auto;
  object-fit: contain;
}

/* 英文版运动打卡补充图 */
.module-record .record-sport-img {
  position: absolute;
  top: 650px;
  left: 660px;
  width: 300px;
  height: auto;
  object-fit: contain;
  z-index: 11;
}

/* 入场动效 */

/* 标题/下划线/小标题入场 */
.module-record .section-title,
.module-record .section-divider,
.module-record .section-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-record.is-visible .section-title,
.module-record.is-visible .section-divider,
.module-record.is-visible .section-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 主图 */
.module-record .block-img {
  opacity: 0;
  transform: translateY(48px);
}

.module-record.is-visible .block-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 英文补充图 */
.module-record .record-sport-img {
  opacity: 0;
  transform: translateY(48px);
}

.module-record.is-visible .record-sport-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 模块五：AGP 报告 */

/* 浅灰背景 */
.module-scene {
  background: #F5F5F5;
}

/* 布局：标题区 + 左文右图 */
.module-scene .agp-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 160px;
}

.module-scene .agp-header {
  text-align: center;
}

.module-scene .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 40px;
  color: #000000;
  line-height: 1.2;
  margin: 80px 0 24px 0;
}

.module-scene .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #8C8C8C;
  margin: 0 0 40px 0;
}

/* 左文右图 */
.module-scene .agp-body {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 文字区 */
.module-scene .agp-text {
  width: 950px;
  text-align: left;
}

/* 正文容器 */
.module-scene .agp-points {
  margin: 0 20px 0 50px;
}

.module-scene .agp-point {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 60px;
}

.module-scene .agp-point:last-child {
  margin-bottom: 20px;
}

/* 正文图标 */
.module-scene .agp-point-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-top: 4px;
}

.module-scene .agp-point-text {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  line-height: 1.8;
  white-space: pre-line;
  margin: 0;
}

/* AGP 图谱 */
.module-scene .agp-img {
  height: 520px;
  width: auto;
  object-fit: contain;
  transform: translate(80px, 10px);
}

/* 入场动效 */

/* 标题/下划线/小标题入场 */
.module-scene .section-title,
.module-scene .section-divider,
.module-scene .section-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-scene.is-visible .section-title,
.module-scene.is-visible .section-divider,
.module-scene.is-visible .section-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 三行文字依次错开 */
.reveal-section .agp-points .agp-point {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .agp-points .agp-point {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

.reveal-section.is-visible .agp-points .agp-point:nth-child(2) {
  transition-delay: 0.6s;
}

.reveal-section.is-visible .agp-points .agp-point:nth-child(3) {
  transition-delay: 0.8s;
}

/* 叠加图自身的 translate 偏移 */
.module-scene .agp-img {
  opacity: 0;
  transform: translate(80px, 10px) translateY(30px);
}

.module-scene.is-visible .agp-img {
  opacity: 1;
  transform: translate(80px, 10px);
  transition: opacity 1.1s ease 0.8s,
    transform 1.1s ease 0.8s;
}

/* 模块六：血糖分析 */

/* 白色背景 */
.module-analysis {
  background: #FFFFFF;
}

/* 布局 */
.module-analysis .analysis-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 220px;
}

/* 标题区（抬高避免被血糖图遮挡） */
.module-analysis .analysis-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.module-analysis .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 0 0 20px 0;
}

.module-analysis .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #868686;
  margin: 0 0 0 30px;
}

/* 英文版小标题位置 + 入场（隐藏态在 -10px 定位基础上再下移 30px，入场回到 -10px） */
:lang(en) .module-analysis .section-subtitle {
  font-size: 30px;
  transform: translate(0, 20px);
}

:lang(en) .module-analysis.is-visible .section-subtitle {
  transform: translate(0, -10px);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 左图右文 */
.module-analysis .analysis-body {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  width: 100%;
}

/* 报告图 */
.module-analysis .analysis-report-img {
  height: 730px;
  width: auto;
  object-fit: contain;
  transform: translate(-110px, -95px);
}

/* 文字区 */
.module-analysis .analysis-text {
  width: 600px;
  text-align: left;
  transform: translate(-70px, -60px);
}

.module-analysis .analysis-expert-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 450;
  font-size: 36px;
  color: #000000;
  margin: 0 0 30px 0;
  transform: translate(-40px, -100px);
}

/* 正文列表 */
.module-analysis .analysis-points {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  transform: translate(-30px, -100px);
}

.module-analysis .analysis-point {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 20px;
  color: #868686;
  line-height: 1.4;
  margin: 0 0 16px 0;
  position: relative;
  padding-left: 20px;
}

.module-analysis .analysis-point::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #CCCCCC;
}

/* 英文版首字母大写 */
:lang(en) .module-analysis .analysis-point {
  text-transform: capitalize;
}

/* 血糖图 */
.module-analysis .analysis-glu-img {
  position: absolute;
  right: 30px;
  bottom: 130px;
  width: 980px;
  height: auto;
  object-fit: contain;
  z-index: 1;
}

/* 入场动效 */

/* 标题/下划线/小标题入场 */
.module-analysis .section-title,
.module-analysis .section-divider,
.module-analysis .section-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-analysis.is-visible .section-title,
.module-analysis.is-visible .section-divider,
.module-analysis.is-visible .section-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 报告图 */
.reveal-section .analysis-report-img {
  opacity: 0;
  transform: translate(-110px, -95px) translateX(-60px);
}

.reveal-section.is-visible .analysis-report-img {
  opacity: 1;
  transform: translate(-110px, -95px) translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 血糖图，延迟入场 */
.reveal-section .analysis-glu-img {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .analysis-glu-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 文字区入场 */
.reveal-section .analysis-text {
  opacity: 0;
  transform: translate(-70px, -60px) translateY(30px);
}

.reveal-section.is-visible .analysis-text {
  opacity: 1;
  transform: translate(-70px, -60px);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 模块七：三大模式 */

/* 浅灰背景 */
.module-model {
  background: #F5F5F5;
}

/* 布局 */
.module-model .model-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 220px;
}

.module-model .model-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.module-model .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 0 0 20px 0;
}

.module-model .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #868686;
  margin: 0 0 50px 0;
}

/* 卡片容器 */
.module-model .model-cards {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
}

/* 手机端模式名（桌面隐藏） */
.module-model .model-active-name {
  display: none;
}

/* 卡片 */
.module-model .model-card {
  width: 320px;
  height: 560px;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

/* 卡片图片 */
.module-model .model-card-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  margin-top: 0;
  transition: filter 0.3s ease;
}

/* 悬停遮罩 */
.module-model .model-card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 24px;
  box-sizing: border-box;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 10;
}

.module-model .model-card:hover .model-card-overlay {
  opacity: 1;
}

.module-model .model-card:hover .model-card-img {
  filter: blur(6px);
}

.module-model .overlay-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 550;
  font-size: 24px;
  color: #FFFFFF;
  margin: 0 0 16px 0;
}

/* 遮罩标题下划线 */
.module-model .overlay-title::after {
  content: '';
  display: block;
  width: 96px;
  height: 1px;
  background-color: #FFFFFF;
  margin-top: 10px;
}

.module-model .overlay-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 1.8;
  margin: 0;
  text-align: left;
}

/* 入场动效 */

/* 标题/下划线/小标题入场 */
.module-model .section-title,
.module-model .section-divider,
.module-model .section-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-model.is-visible .section-title,
.module-model.is-visible .section-divider,
.module-model.is-visible .section-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

.reveal-section .model-card-img {
  opacity: 0;
  transform: translateY(24px);
}

/* 依次错开 */
.reveal-section.is-visible .model-cards .model-card:nth-child(1) .model-card-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.4s,
    filter 0.3s ease;
}

.reveal-section.is-visible .model-cards .model-card:nth-child(2) .model-card-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.4s,
    filter 0.3s ease;
}

.reveal-section.is-visible .model-cards .model-card:nth-child(3) .model-card-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.4s,
    filter 0.3s ease;
}

/* 模块八：官方商城 */

.module-shop {
  background: #FFFFFF;
}

/* 英文版隐藏商城 */
:lang(en) .module-shop {
  display: none;
}

/* 大标题 */
.module-shop .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 50px;
  color: #000000;
  line-height: 1.2;
  position: relative;
  top: -140px;
}

/* 三个入口 */
.shop-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 240px;
  position: relative;
  top: 10px;
}

.shop-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-decoration: none;
}

.shop-link img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.shop-link:hover img {
  transform: scale(1.15);
}
.shop-link span {
  font-size: 20px;
  color: #666;
}

.shop-link span::after {
  content: ' ›';
  color: #00ADBB;
  font-size: 30px;
}

/* 入场动效：标题 0.3s，三个图标 0.5s */
.module-shop .section-title {
  opacity: 0;
  transform: translateY(30px);
}

.module-shop.is-visible .section-title {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.3s,
    transform 1.1s ease 0.3s;
}

.module-shop .shop-links {
  opacity: 0;
  transform: translateY(30px);
}

.module-shop.is-visible .shop-links {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.5s,
    transform 1.1s ease 0.5s;
}

/* 页脚吸附 */

.product-page >>> .footer {
  scroll-snap-align: end;
}

/* 移动端 */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
    align-self: stretch;
  }

  /* 禁止 flex 压缩，避免分割线被压成 0 */
  .product-page .section-inner * {
    flex-shrink: 0;
  }

  /* 内容块顶对齐，预留导航高度 */
  .block-content {
    justify-content: flex-start;
    padding-top: 76px;
  }

  /* 模块一：首屏 */

  /* 首屏改纵向文档流 */
  .module-hero .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding-top: 76px;
  }

  /* 介绍文字排最上 */
  .hero-desc {
    order: 1;
    position: static;
    width: auto;
    padding: 0 10%;
    box-sizing: border-box;
    text-align: center;
  }

  .hero-desc .hero-title {
    font-size: 5.87vw;
    margin-bottom: 1vh;
  }

  .hero-desc .hero-subtitle {
    font-size: 6.93vw;
    margin-bottom: 2vh;
  }

  .hero-desc .hero-text {
    font-size: 3.47vw;
    line-height: 1.6;
    text-align: justify;
    white-space: normal;
  }

  :lang(en) .hero-desc .hero-title {
    font-size: 5vw;
  }

  :lang(en) .hero-desc .hero-subtitle {
    font-size: 4.1vw;
  }

  :lang(en) .hero-desc .hero-text {
    font-size: 3vw;
    line-height: 1.5;
  }

  /* wifi 图排在文字下方 */
  .section-overlay-hero-wifi {
    order: 2;
    position: static;
    transform: none;
    width: auto;
    height: auto;
    max-width: 26%;
    max-height: 12vh;
    margin: 5vh 0 0 0;
  }

  /* 手机图排最底部 */
  .section-overlay-hero-phone {
    order: 3;
    position: static;
    transform: none;
    width: auto;
    height: auto;
    max-width: 34%;
    max-height: 26vh;
    margin: 2vh 0 0 0;
  }

  /* 模块二：产品特点 */

  /* 允许收缩以填满一屏 */
  .module-bluetooth .feature-grid,
  .module-bluetooth .feature-top,
  .module-bluetooth .feature-col,
  .module-bluetooth .painless-card,
  .module-bluetooth .bluetooth-card,
  .module-bluetooth .calib-card,
  .module-bluetooth .report-card,
  .module-bluetooth .painless-img,
  .module-bluetooth .bluetooth-img,
  .module-bluetooth .calib-img,
  .module-bluetooth .report-img {
    flex-shrink: 1;
  }

  /* 容器固定高度，上下两块绝对定位钉死 */
  .feature-grid {
    position: relative;
    transform: none;
    left: 0;
    top: auto;
    width: 100%;
    height: var(--app-height, 100vh);
    padding: 0;
    box-sizing: border-box;
  }

  /* 模块二手机端：关闭入场动效 */
  .module-bluetooth .section-inner,
  .module-bluetooth .painless-card,
  .module-bluetooth .bluetooth-card,
  .module-bluetooth .calib-card,
  .module-bluetooth .compact-card,
  .module-bluetooth .report-card {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }

  /* 上部两块区域 */
  .feature-top {
    position: absolute;
    top: 76px;
    left: 4%;
    right: 4%;
    bottom: calc(16% + 3.5%);
    display: flex;
    flex-direction: row;
    gap: 2vw;
    overflow: hidden;
  }

  /* 列容器 */
  .feature-col {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    gap: 1.5vh;
  }

  /* 灰块基础样式 */
  .painless-card,
  .bluetooth-card,
  .calib-card,
  .compact-card,
  .report-card {
    position: static;
    width: 100%;
    flex: 1;
    min-height: 0;
    padding: 1.5vh 4vw;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /* 各灰块高度比例 */

  /* 无痛佩戴 */
  .painless-card {
    flex: 3;
    padding-bottom: 0;
  }

  /* 蓝牙传输 */
  .bluetooth-card {
    flex: 2;
    padding-bottom: 0;
  }

  /* 无需校准 */
  .calib-card {
    flex: 3;
    padding-bottom: 0;
  }

  /* 数据报告 */
  .report-card {
    padding-bottom: 0;
    flex: 2;
  }

  .painless-card .painless-title,
  .bluetooth-card .bluetooth-title,
  .calib-card .calib-title,
  .compact-card .compact-title,
  .report-card .report-title {
    font-size: 3.73vw;
    margin-bottom: 0.5vh;
    flex-shrink: 0;
  }

  .painless-card .painless-desc,
  .bluetooth-card .bluetooth-desc,
  .calib-card .calib-desc,
  .compact-card .compact-desc,
  .report-card .report-desc {
    font-size: 2.93vw;
    white-space: pre-line;
    flex-shrink: 0;
  }

  /* 英文版字号 */
  :lang(en) .painless-card .painless-title,
  :lang(en) .bluetooth-card .bluetooth-title,
  :lang(en) .calib-card .calib-title,
  :lang(en) .compact-card .compact-title,
  :lang(en) .report-card .report-title {
    font-size: 3.2vw;
  }

  :lang(en) .painless-card .painless-desc,
  :lang(en) .bluetooth-card .bluetooth-desc,
  :lang(en) .calib-card .calib-desc,
  :lang(en) .compact-card .compact-desc,
  :lang(en) .report-card .report-desc {
    font-size: 2.67vw;
  }

  /* 块内图片 */
  .painless-card .painless-img,
  .bluetooth-card .bluetooth-img,
  .calib-card .calib-img,
  .compact-card .compact-img,
  .report-card .report-img {
    position: static;
    transform: none;
    display: block;
    flex: 1;
    min-height: 0;
    width: 100%;
    height: auto;
    max-height: 100%;
    margin: 0.5vh auto 0;
    object-fit: contain;
  }

  /* 人物图 */
  .painless-card .painless-img {
    width: 70%;
    object-fit: cover;
    object-position: top center;
  }

  /* 蓝牙图标 */
  .bluetooth-card .bluetooth-img {
    width: 55%;
  }

  /* 产品图 */
  .calib-card .calib-img {
    width: 100%;
  }

  /* 小巧便携：底部通栏 */
  .compact-card {
    position: absolute;
    top: auto;
    left: 4%;
    right: 4%;
    bottom: 2%;
    width: auto;
    height: 16%;
    //justify-content: center;
    padding-right: 40%;
  }

  .compact-card .compact-img {
    position: absolute;
    right: 5%;
    top: 60%;
    transform: translateY(-50%);
    width: 36%;
    height: auto;
    margin: 0;
    object-fit: contain;
    flex: none;
    z-index: 0;
  }

  /* 图谱 */
  .report-card .report-img {
    width: 100%;
  }

  /* 模块三：应用场景 */

  /* 标题区 */
  .module-compact .section-title {
    font-size: 5.87vw;
    line-height: 1.4;
    margin: 0 0 1vh 0;
  }

  .module-compact .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-compact .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 3vh 0;
  }

  /* 2×2 网格 */
  .scene-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2vh;
    width: 80%;
    margin-top: 0;
  }

  /* 白块 */
  .scene-grid .scene-block {
    width: auto;
    height: auto;
    aspect-ratio: 330 / 498;
    border-radius: 12px;
    padding: 10px 10px 0 0;
  }

  /* 块内标题 */
  .scene-grid .scene-block-title {
    font-size: 3.47vw;
    margin-top: 4px;
    padding-left: 10px;
  }

  /* 场景图 */
  .scene-grid .scene-block-img {
    width: 86%;
    margin: 10px auto 0;
    transform: translateX(4px);
  }

  /* 英文版字号 */
  :lang(en) .module-compact .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-compact .section-subtitle {
    font-size: 3.2vw;
  }

  :lang(en) .scene-grid .scene-block-title {
    font-size: 3.2vw;
  }

  /* 模块四：控糖打卡 */

  /* 标题区 */
  .module-record .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-record .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-record .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 6vh 0;
  }

  /* 手机端专用图 */
  .module-record .record-mobile-img {
    width: 88%;
    height: auto;
    max-height: 70vh;
    object-fit: contain;
    /* 入场位移基准 */
    opacity: 0;
    transform: translateY(48px);
  }

  /* 入场动效 */
  .module-record.is-visible .record-mobile-img {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.1s ease 0.2s,
      transform 1.1s ease 0.2s;
  }

  :lang(en) .module-record .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-record .section-subtitle {
    font-size: 3.2vw;
  }

  /* 模块五：AGP 报告 */

  /* 布局 */
  .module-scene .agp-layout {
    padding-top: 76px;
  }

  /* 标题区 */
  .module-scene .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-scene .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-scene .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 3vh 0;
  }

  /* 改为上下堆叠 */
  .module-scene .agp-body {
    flex-direction: column;
    gap: 3vh;
  }

  /* 文字区 */
  .module-scene .agp-text {
    width: auto;
    align-self: stretch;
    padding: 0 5% 0 4%;
  }

  .module-scene .agp-points {
    margin: 0;
  }

  .module-scene .agp-point {
    gap: 10px;
    margin-bottom: 3vh;
  }

  .module-scene .agp-point:last-child {
    margin-bottom: 2vh;
  }

  .module-scene .agp-point-icon {
    width: 3vh;
    height: 3vh;
    margin-top: 2px;
  }

  .module-scene .agp-point-text {
    /* 允许收缩换行 */
    flex-shrink: 1;
    min-width: 0;
    font-size: 3.73vw;
    line-height: 1.6;
  }

  /* AGP 图 */
  .module-scene .agp-img {
    width: 92%;
    height: auto;
    max-height: 40vh;
    /* 入场位移基准 */
    transform: translateY(24px);
  }

  /* 覆盖桌面偏移，避免入场跳变 */
  .module-scene.is-visible .agp-img {
    transform: translateY(0);
  }

  :lang(en) .module-scene .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-scene .section-subtitle {
    font-size: 3.2vw;
  }

  :lang(en) .module-scene .agp-point-text {
    text-align: justify;
    font-size: 3.2vw;
  }

  :lang(en) .module-scene .agp-point {
    gap: 10px;
    margin-bottom: 2vh;
  }

  :lang(en) .module-scene .agp-point:last-child {
    margin-bottom: 0;
  }

  /* 英文版 AGP 图 */
  :lang(en) .module-scene .agp-img {
    width: 92%;
    max-height: 36vh;
  }

  /* 模块六：血糖分析 */

  /* 布局 */
  .module-analysis .analysis-layout {
    padding-top: 76px;
  }

  /* 标题区 */
  .module-analysis .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-analysis .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-analysis .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 2vh 0;
  }

  /* 改为上下堆叠 */
  .module-analysis .analysis-body {
    flex-direction: column;
    gap: 1vh;
  }

  /* 报告图 */
  .module-analysis .analysis-report-img {
    order: 3;
    width: 80%;
    height: auto;
    max-height: 80vh;

    transform: translateY(24px);
  }

  /* 英文版报告图 */
  :lang(en) .module-analysis .analysis-report-img {
    width: 76%;
    max-height: 80vh;
  }

  /* 文字区 */
  .module-analysis .analysis-text {
    order: 1;
    width: auto;
    align-self: stretch;
    padding: 0 4%;
    transform: translateY(30px);
  }

  /* 文字区入场 */
  .module-analysis.is-visible .analysis-text {
    transform: translateY(0);
  }

  .module-analysis .analysis-expert-title {
    font-size: 4.27vw;
    margin: 0 0 8px 0;
    transform: none;
  }

  .module-analysis .analysis-points {
    margin: 0;
    transform: none;
  }

  .module-analysis .analysis-point {
    font-size: 3.2vw;
    margin: 0 0 0.5vh 0;
    padding-left: 14px;
  }

  :lang(en) .module-analysis .analysis-point {
    font-size: 3vw;
    margin: 0 0 0.5vh 0;
  }

  .module-analysis .analysis-point::before {
    width: 6px;
    height: 6px;
    top: 5px;
  }

  /* 血糖图 */
  .module-analysis .analysis-glu-img {
    position: static;
    order: 2;
    width: 92%;
    height: auto;
    max-height: 20vh;
    margin-top: 1vh;
  }

  /* 英文版血糖图 */
  :lang(en) .module-analysis .analysis-glu-img {
    width: 92%;
    max-height: 20vh;
    margin-top: 0;
  }

  /* 覆盖桌面偏移，避免入场跳变 */
  .module-analysis.is-visible .analysis-report-img {
    transform: translateY(0);
  }

  :lang(en) .module-analysis .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-analysis .section-divider {
    width: 200px;
    margin: 0 auto 3vh;
  }

  :lang(en) .module-analysis .section-subtitle {
    font-size: 3.2vw;
    margin: 0 0 0.2vh 0;
  }

  /* 模块七：三大模式 */

  /* 布局 */
  .module-model .model-layout {
    padding-top: 76px;
  }

  /* 标题区 */
  .module-model .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-model .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-model .section-subtitle {
    font-size: 3.73vw;
    margin: 0 12vh 3vh 12vh;
    text-align: center;
  }

  /* 横向轮播 */
  .module-model .model-cards {
    display: block;
    position: relative;
    width: 100%;
    height: 108vw;
    overflow: hidden;
  }

  /* 卡片 */
  .module-model .model-card {
    position: absolute;
    top: 50%;
    width: 52vw;
    height: auto;
    aspect-ratio: 480 / 972;
    background: transparent;
    box-shadow: none;
    cursor: pointer;
    transition: left 0.5s ease, transform 0.5s ease, opacity 0.5s ease;
  }

  /* 中间卡 */
  .module-model .model-card.role-0 {
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    z-index: 3;
    opacity: 1;
  }

  /* 右侧卡 */
  .module-model .model-card.role-1 {
    left: 96%;
    transform: translate(-50%, -50%) scale(0.7);
    z-index: 1;
    opacity: 0.95;
  }

  /* 左侧卡 */
  .module-model .model-card.role-2 {
    left: 4%;
    transform: translate(-50%, -50%) scale(0.7);
    z-index: 1;
    opacity: 0.95;
  }

  /* 横穿的第三张卡压到底层 */
  .module-model .model-card.is-passing {
    z-index: 0;
  }

  /* 手机端禁用 hover 遮罩 */
  .module-model .model-card:hover .model-card-overlay {
    opacity: 0;
  }

  .module-model .model-card:hover .model-card-img {
    filter: none;
  }

  /* 点击中间卡展开的介绍遮罩 */
  .module-model .model-card.show-info .model-card-overlay {
    opacity: 1;
  }

  .module-model .model-card.show-info .model-card-img {
    filter: blur(6px);
  }

  /* 遮罩层 */
  .module-model .model-card-overlay {
    padding: 3vh 5vw;
  }

  .module-model .overlay-title {
    font-size: 4.5vw;
    margin: 0 0 1.2vh 0;
  }

  .module-model .overlay-title::after {
    width: 12vw;
    margin-top: 1.2vh;
  }

  .module-model .overlay-desc {
    font-size: 3.8vw;
    line-height: 1.6;
  }

  /* 英文版遮罩字号 */
  :lang(en) .module-model .overlay-title {
    font-size: 4.5vw;
  }

  :lang(en) .module-model .overlay-desc {
    font-size: 3.2vw;
    line-height: 1.6;
  }

  .module-model .model-active-name {
    display: block;
    text-align: center;
    font-size: 4.8vw;
    font-weight: 550;
    color: #252525;
    margin: 2vh 0 0 0;
  }

  :lang(en) .module-model .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-model .section-subtitle {
    font-size: 3.2vw;
  }

  /* 模块八：官方商城 */

  /* 大标题 */
  .module-shop .section-title {
    font-size: 7vw;
    transform: none;
    margin-top: 25vh;
  }

  /* 入口改竖向堆叠 */
  .shop-links {
    flex-direction: column;
    align-items: center;
    gap: 8vh;
    margin-top: -12vh;
  }

  .shop-link {
    gap: 1vh;
  }

  .shop-link img {
    width: 8vh;
    height: 8vh;
  }

  .shop-link span {
    font-size: 3.47vw;
  }

  .shop-link span::after {
    font-size: 5vw;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }

  /* 手机图：取消缩放但保留居中位移 */
  .reveal-section .section-overlay-hero-phone {
    transition: none;
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
</style>

<!-- 产品页导航栏样式 -->
<style>
/* 导航栏背景过渡 */
.header {
  transition: background-color 0.3s ease;
}

/* 首屏可见时导航栏透明 */
.header.header-transparent {
  background: transparent;
}

/* 透明态文字变白 */
.header.header-transparent .nav-item,
.header.header-transparent .lang-text {
  color: #FFFFFF;
}
</style>
